export enum Justify {
  SpaceBetween = "space-between",
  SpaceAround = "space-around",
  Start = "flex-start",
  end = "flex-end",
}
